module.exports = __webpack_public_path__ + "img/logo36.59d2c42e.png";